module.exports = __webpack_public_path__ + "img/503-42dfb3.png";